// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2Za4X","footer":"ModalFilter_footer__3F0Ah"};